import React from 'react';
import { Outlet } from 'react-router-dom';
import TripSubNavigation from './trips-subnav';

const View = () => (
  <>
    <TripSubNavigation />
    <Outlet />
  </>
);

export default View;
